export default {
    data () {
        return {
            fillPhoneNumberMask: false,
        }
    },

    methods: {
        focusPhoneNumber (event) {
            this.fillPhoneNumberMask = true;

            setTimeout(function () {
                event.target.selectionStart = 4;
                event.target.selectionEnd = 4;
            }, 25);
        },

        blurPhoneNumber (event, callback) {
            this.fillPhoneNumberMask = false;

            if (this.getPhoneNumber && (typeof this.getPhoneNumber === 'function')) {
                if (!this.validatePhoneNumber(this.getPhoneNumber())) {
                    if (callback) {
                        callback();
                    } else if (this.setPhoneNumberCallback && (typeof this.setPhoneNumberCallback === 'function')) {
                        this.setPhoneNumberCallback('');
                    } else {
                        console.log('Phone number validation callback is not defined');
                    }
                }
            } else {
                console.log('getPhoneNumber is not defined');
            }
        },

        validatePhoneNumber (phoneNumber) {
            let regex = new RegExp('^\\+7\\s\\(\\d{3}\\)\\s\\d{3}\\-\\d{2}\\-\\d{2}$');

            if (! regex.test(phoneNumber)) {
                return false;
            }

            return true;
        }
    },
};
